import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordConfirm } from '@app/shared/components/form/validators';
import { ToastService } from '@teorema/patron';
import { Subscription } from 'rxjs';
import { CoreConfig } from 'src/app/models/core-config.model';
import { User } from 'src/app/models/user.model';
import { utils } from 'src/app/shared';
import { AuthService } from '../auth.service';

@Component({
  templateUrl: './change-password.component.html',
  standalone: false,
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  user?: User;
  config?: CoreConfig;
  redirectPath?: string;
  formGroup!: FormGroup;
  sub?: Subscription;
  loading: boolean = false;

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private toast: ToastService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.config = this.authService.getCoreConfig();
    setTimeout(() => {
      this.titleService.setTitle(`Alterar senha | ${this.config?.panelTitle}`);
    }, 100);

    this.user = utils.getUser();
    this.formGroup = this.formBuilder.group(
      {
        userEmail: [{ value: this.user.email, disabled: true }],
        currentPassword: [''],
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      },
      {
        validator: PasswordConfirm('newPassword', 'confirmPassword'),
      }
    );

    // temp_password vem da claim do token (acesso via link de redefinição), quando o
    // usuário justamente não sabe a senha atual.
    if (!this.user.is_temp_password && !this.user.temp_password) {
      this.formGroup
        .get('currentPassword')
        ?.addValidators([Validators.required, Validators.minLength(6)]);
    }

    this.sub = this.activatedRoute.queryParams.subscribe(params => {
      this.redirectPath = params?.['redirect'] || this.config?.redirectPathAfterLogin;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.titleService.setTitle(this.config?.panelTitle!);
  }

  goToPanel() {
    this.router.navigate([this.config?.redirectPathAfterLogin]);
  }

  async submit(event: any) {
    this.loading = true;
    const user = await this.authService
      .changePassword(event.currentPassword, event.newPassword)
      .catch(response => {
        const errorMessage = response?.error?.message || 'Houve um erro ao alterar a senha.';
        this.toast.show({ color: 'error', message: errorMessage });
      });

    if (user?.id) {
      this.toast.show({ color: 'success', message: 'Sua senha foi alterada!' });
      this.formGroup.reset();
      const updatedUser = await this.authService.me();
      utils.setUser(updatedUser);
      this.ngOnInit();
    }
    this.loading = false;
  }
}
